import { Pipe } from "@angular/core";

@Pipe({
    name: 'repeat',
    standalone: false
})
export class RepeatPipe {
    transform(value: number, count: any) {
        return Array(count).fill(value);
    }
}